import React from 'react';

export const DEFAULT_CONTENT = (
  <React.Fragment>
    Show me loan terms for
  </React.Fragment>
);

